var _path, _path2, _path3, _path4, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 5.375V3.625H5.375L8 1L10.625 3.625H8.875V5.375H7.125Z",
    fill: "#626262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 10.625V12.375H5.375L8 15L10.625 12.375H8.875V10.625H7.125Z",
    fill: "#626262"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 8.875L12.375 8.875L12.375 10.625L15 8L12.375 5.375L12.375 7.125L10.625 7.125L10.625 8.875Z",
    fill: "#626262"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 7.125L3.625 7.125L3.625 5.375L1 8L3.625 10.625L3.625 8.875L5.375 8.875L5.375 7.125Z",
    fill: "#626262"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.75,
    y: 6.75,
    width: 2.5,
    height: 2.5,
    stroke: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.f706fb1a01946cf7e67eea17a55a0aa5.svg";
export { ForwardRef as ReactComponent };